import type { PropsWithChildren } from 'react';
import type { TypographyToken } from '@elfsight/widget-ui';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT, STYLE_DEFAULTS } from '../../common';

export function PaymentErrorMessage({
  children,
  color = STYLE_DEFAULTS.errorColor,
  textToken = 'text15'
}: PropsWithChildren<{ color?: string; textToken?: TypographyToken }>) {
  return (
    <Typography
      textToken={textToken}
      color={color}
      className={createReadableClass({
        component: CLASS_COMPONENT,
        element: 'payment-error-message'
      })}
    >
      {children}
    </Typography>
  );
}
